import { Node, Transforms } from 'slate';
import { ReactEditor } from 'slate-react';
import { AnyObject } from 'types';

type CustomNode = Node & AnyObject;

export type SaveNode = (node: CustomNode) => CustomNode;

export default function saveNode(editor) {
  return function (node: CustomNode) {
    const at = ReactEditor.findPath(editor, node);

    Transforms.setNodes(editor, node, { at });
  };
}
